<template>
    <div class="card-inner" :class="{'active':$route.name=='Works'}" id="works-card">
        <div class="card-wrap">
            <!--
						Works
            -->
            <div class="content works">
                <!-- title -->
                <div class="title">
                    {{$t("works.001")}}
                    <span class="subtitle fz-rem5">({{$t("works.001_01")}})</span>
                </div>

                <!-- filters -->
                <div class="filter-menu filter-button-group">
                    <div class="f_btn" :class="{'active':item.value==showType}" v-for="(item,index) in showList" :key="index">
                        <div name="showType" v-text="item.name" @click="showType = item.value"></div>
                    </div>
                </div>

                <div class="row grid-items border-line-v">
                    <transition-group name="fade" mode="in-out">
                        <template v-for="(item, index) in workList">
                            <div
                                :key="index"
                                v-show="showType==item.workType||showType=='all'"
                                class="col col-d-6 col-t-6 col-m-12 grid-item photo border-line-h"
                            >
                                <div class="box-item">
                                    <div @click="showAlbum(item)" class="image">
                                        <a class="has-popup-image">
                                            <img :src="require('@/assets/images/works/'+item.img)" alt />
                                            <span class="info">
                                                <span :class="item.hoverImg"></span>
                                            </span>
                                        </a>
                                    </div>
                                    <div class="desc">
                                        <a class="name has-popup-image" v-text="item.name"></a>
                                        <div class="category" v-text="item.workType"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </transition-group>
                </div>
                <VueEasyLightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></VueEasyLightbox>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
export default {
    data() {
        return {
            visible: false,
            index: 0, // default
            showType: "all",
            imgs: [],
            workList: [
                {
                    album: "cheer",
                    img: "cheerSys.jpg",
                    hoverImg: "ion ion-image",
                    name: this.$t("works.006"),
                    workType: "other"
                },
                { album: "smart", img: "smart.jpg", hoverImg: "ion ion-image", name: this.$t("works.007"), workType: "activity" },
                {
                    album: "modernWeb19",
                    img: "modernWeb19.jpg",
                    hoverImg: "ion ion-image",
                    name: "Modern Web19",
                    workType: "activity"
                },
                { album: "o9m", img: "9mLogin.jpg", hoverImg: "ion ion-image", name: this.$t("works.008"), workType: "work" },
                { album: "n9m", img: "new9m.jpg", hoverImg: "ion ion-image", name: this.$t("works.009"), workType: "work" },
                { album: "ithelp", img: "ithelp.jpg", hoverImg: "ion ion-image", name: this.$t("works.010"), workType: "other" },
                { album: "gacc", img: "gacc.jpg", hoverImg: "ion ion-image", name: this.$t("works.011"), workType: "work" }
            ]
        };
    },
    computed: {
        showList() {
            return [
                { name: this.$t("works.002"), value: "all" },
                { name: this.$t("works.003"), value: "work" },
                { name: this.$t("works.004"), value: "activity" },
                { name: this.$t("works.005"), value: "other" }
            ];
        }
    },
    methods: {
        showAlbum(album) {
            const _this = this;
            if (album.workType === "work") {
                Swal.fire({
                    title: this.$t("works.012"),
                    input: "password",
                    inputPlaceholder: "Enter your password",
                    inputAttributes: {
                        maxlength: 10,
                        autocapitalize: "off",
                        autocorrect: "off"
                    }
                }).then(obj => {
                    let pwd = _this.passAdd(obj.value);
                    for (let i = 0; i < 10; i++) {
                        pwd = _this.passAdd(pwd);
                    }
                    if (pwd === "CTVDREXFXY") {
                        _this.imgs = [];
                        for (let i = 0; i < 5; i++) {
                            _this.imgs.push(require(`@/assets/images/works/${album.album}/${album.album}${i}.jpg`));
                        }
                        _this.visible = true;
                    } else {
                        Swal.fire({
                            type: "error",
                            title: this.$t("works.013"),
                            html: this.$t("works.014")
                        });
                    }
                });
            } else {
                _this.imgs = [];
                for (let i = 0; i < 5; i++) {
                    _this.imgs.push(require(`@/assets/images/works/${album.album}/${album.album}${i}.jpg`));
                }
                _this.visible = true;
            }
        },
        handleHide() {
            this.visible = false;
            this.imgs = [];
        },
        passAdd(str) {
            var str1 = [];
            if (str != undefined) {
                for (var i = 0; i < str.length; i++) {
                    var num = str[i].charCodeAt();
                    if (num >= 0 && num <= 77) {
                        num = num + 13;
                    } else if (num > 77 && num < 1000) {
                        num = num - 13;
                    }
                    str1.push(String.fromCharCode(num));
                }
            }

            return str1.join("");
        }
    },
    components: {
        VueEasyLightbox
    }
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
    animation: fadeInDown 1s;
}
.fade-leave-active {
    animation: fadeOutUp 1s;
}
</style>


// WEBPACK FOOTER //
// src/components/Works.vue